import React from "react";

function Event_summit(){
return(
  <div></div>
);
}

export default Event_summit;